export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_SEARCHING = 'SET_IS_SEARCHING';
export const PUSH_ALERT = 'PUSH_ALERT';
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const RESET_ALERT = 'RESET_ALERT';
export const SET_TIMELINE_FIXED = 'SET_TIMELINE_FIXED';
export const SET_IS_MINI_VARIANT = 'SET_IS_MINI_VARIANT';
